import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import PageWrapper from "../../../../components/layout/page/PageWrapper";
import Text from "../../../../components/typography/Text";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";

import { useVerifyEmail } from "../../hooks/useVerifyEmail";

import "./VerifyEmailPage.css";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const { status } = useVerifyEmail(token, navigate);

  useEffect(() => {
    document.title = "Katch | Verify Email";
  }, []);

  const handleSignIn = () => navigate("/sign-in");

  const renderContent = () => {
    if (status.loading) {
      return (
        <Text
          as="p"
          size="sm"
          tone="secondary"
          className="verify-email-page__loading"
        >
          Verifying your email...
        </Text>
      );
    }

    if (status.success) {
      return (
        <FeedbackStatus
          title="Email verified"
          description={`${status.message || "Your email has been verified."} Redirecting to sign in...`}
          buttonText="Back to Sign in"
          onAction={handleSignIn}
        />
      );
    }

    return (
      <FeedbackStatus
        title={
          status.alreadyVerified ? "Already verified" : "Verification failed"
        }
        description={
          status.message || "Unable to verify your email. Please try again."
        }
        buttonText="Back to Sign in"
        onAction={handleSignIn}
      />
    );
  };

  return (
    <PageWrapper className="verify-email-wrapper">
      <main className="verify-email-page">
        <div className="verify-email-page__content">{renderContent()}</div>
      </main>
    </PageWrapper>
  );
}
